import { useState, useEffect, useRef } from "react"

import Style from "./style"
import pwHide from "./asset/pwHide.svg"
import pwShow from "./asset/pwShow.svg"

import usePostUtilSms from "entity/util/usePostUtilSms"
import usePostUtilSmsConfirm from "entity/util/usePostUtilSmsConfirm"
import usePutManagerPassowrd from "entity/auth/usePutManagerPassowrd"

import DefaultButton from "shared/ui/DefaultButton"
import DefaultInput from "shared/ui/DefaultInput"
import useConfrimCookie from "shared/model/useConfrimCookie"

const FindManagerPw = () => {
    const [isPwShow, setIsPwShow] = useState(false)

    const idRef = useRef()
    const contactRef = useRef()
    const confirmRef = useRef()
    const newPwRef = useRef()

    const [sendState, sendEvent] = usePostUtilSms(contactRef)
    const [confirmEvent] = usePostUtilSmsConfirm(contactRef, confirmRef)
    const [requestPutPassword] = usePutManagerPassowrd(idRef, newPwRef)

    const [confirmCookie, , deleteConfirmCookie] = useConfrimCookie()

    useEffect(() => {
        return () => {
            deleteConfirmCookie()
        }
    }, [])

    return (
        <Style.Wrapper>
            <Style.ContentDiv>
                <h2>매니저 비밀번호 찾기</h2>

                <Style.FormDiv>
                    <DefaultInput label="아이디" inputRef={idRef} placeholder="20글자 이하" />
                    <DefaultInput label="연락처" inputRef={contactRef} placeholder="'-' 없이 숫자만 입력">
                        <DefaultButton small fitWidth clickEvent={sendEvent} deactive={confirmCookie}>인증번호 받기</DefaultButton>
                    </DefaultInput>
                    {sendState &&
                        <div>
                            <DefaultInput label="인증번호" inputRef={confirmRef} placeholder="6글자의 숫자만 입력">
                                <DefaultButton small fitWidth clickEvent={confirmEvent} deactive={confirmCookie}>인증하기</DefaultButton>
                            </DefaultInput>
                            {confirmCookie && <Style.Guide>인증되었습니다.</Style.Guide>}
                        </div>
                    }
                    {confirmCookie &&
                        <>
                            <Style.PasswordContainer>
                                <DefaultInput label="비밀번호" type={isPwShow ? "text" : "password"} inputRef={newPwRef} placeholder="새 비밀번호를 입력해주세요">
                                    <button onClick={() => setIsPwShow(state => !state)}>
                                        <img src={isPwShow ? pwShow : pwHide} />
                                    </button>
                                </DefaultInput>
                                <Style.PasswordGuide>• 6자 이상, 20자 이하</Style.PasswordGuide>
                                <Style.PasswordGuide>• 영문, 숫자, 특수문자를 모두 포함</Style.PasswordGuide>
                            </Style.PasswordContainer>
                        </>
                    }
                </Style.FormDiv>

                <Style.BtnDiv>
                    <DefaultButton clickEvent={requestPutPassword}>비밀번호 변경하기</DefaultButton>
                </Style.BtnDiv>

            </Style.ContentDiv>
        </Style.Wrapper>
    )
}

export default FindManagerPw